export const decodeJwtPayload = (token) => {
  try {
    const payload = token?.split('.')[1];
    if (!payload) return null;

    const normalizedPayload = payload.replace(/-/g, '+').replace(/_/g, '/');
    const decodedPayload = atob(normalizedPayload);

    return JSON.parse(decodedPayload);
  } catch (error) {
    return null;
  }
};

export const isJwtExpired = (token) => {
  const payload = decodeJwtPayload(token);
  const expiryInSeconds = payload?.exp;

  if (!expiryInSeconds) {
    return true;
  }

  return expiryInSeconds * 1000 <= Date.now();
};
